export let RegistrationStep;

(function (RegistrationStep) {
  RegistrationStep["BusinessDetails"] = "business-details";
  RegistrationStep["BusinessRepresentative"] = "business-representative";
  RegistrationStep["BusinessAddress"] = "business-address";
  RegistrationStep["BusinessProfile"] = "business-profile";
})(RegistrationStep || (RegistrationStep = {}));

export let NewRegistrationStep;

(function (NewRegistrationStep) {
  NewRegistrationStep["BusinessDetails"] = "business-details";
  NewRegistrationStep["BusinessRepresentative"] = "business-representative";
  NewRegistrationStep["BusinessProfile"] = "business-profile";
})(NewRegistrationStep || (NewRegistrationStep = {}));

export let NewBusinessDetailsField;

(function (NewBusinessDetailsField) {
  NewBusinessDetailsField["LegalCode"] = "businessDetails.legalCode";
  NewBusinessDetailsField["LegalName"] = "businessDetails.legalName";
  NewBusinessDetailsField["RegistrarName"] = "businessDetails.registrarName";
  NewBusinessDetailsField["EntityType"] = "businessDetails.entityType";
  NewBusinessDetailsField["Vat"] = "businessDetails.vat";
  NewBusinessDetailsField["IsVatDisabled"] = "businessDetails.isVatDisabled";
})(NewBusinessDetailsField || (NewBusinessDetailsField = {}));

export let NewBusinessAddressField;

(function (NewBusinessAddressField) {
  NewBusinessAddressField["Country"] = "addresses.businessAddress.countryId";
  NewBusinessAddressField["AddressLine1"] = "addresses.businessAddress.line1";
  NewBusinessAddressField["AddressLine2"] = "addresses.businessAddress.line2";
  NewBusinessAddressField["PostalCode"] = "addresses.businessAddress.postalCode";
  NewBusinessAddressField["City"] = "addresses.businessAddress.city";
  NewBusinessAddressField["FullPostalCode"] = "addresses.businessAddress.fullPostalCode";
  NewBusinessAddressField["IsBusinessEqualToPersonalAddress"] = "addresses.isBusinessEqualToPersonalAddress";
})(NewBusinessAddressField || (NewBusinessAddressField = {}));

export let NewRepresentativeField;

(function (NewRepresentativeField) {
  NewRepresentativeField["FirstNames"] = "businessRepresentative.firstNames";
  NewRepresentativeField["LastName"] = "businessRepresentative.lastName";
  NewRepresentativeField["Birthday"] = "businessRepresentative.birthday";
  NewRepresentativeField["Nationality"] = "businessRepresentative.nationality";
  NewRepresentativeField["Country"] = "businessRepresentative.country";
  NewRepresentativeField["Email"] = "businessRepresentative.email";
  NewRepresentativeField["Ubos"] = "businessRepresentative.ubos";
  NewRepresentativeField["IsSameLegalAddress"] = "businessRepresentative.isSameLegalRepresentativeAddress";
  NewRepresentativeField["RepresentativeCountry"] = "businessRepresentative.legalRepresentativeAddress.countryId";
  NewRepresentativeField["RepresentativeAddressLine1"] = "businessRepresentative.legalRepresentativeAddress.line1";
  NewRepresentativeField["RepresentativeAddressLine2"] = "businessRepresentative.legalRepresentativeAddress.line2";
  NewRepresentativeField["RepresentativePostalCode"] = "businessRepresentative.legalRepresentativeAddress.postalCode";
  NewRepresentativeField["RepresentativeFullPostalCode"] = "businessRepresentative.legalRepresentativeAddress.fullPostalCode";
  NewRepresentativeField["RepresentativeCity"] = "businessRepresentative.legalRepresentativeAddress.city";
})(NewRepresentativeField || (NewRepresentativeField = {}));

export const ORDERED_REGISTRATION_STEPS = [RegistrationStep.BusinessDetails, RegistrationStep.BusinessRepresentative, RegistrationStep.BusinessAddress, RegistrationStep.BusinessProfile];
export const NEW_ORDERED_REGISTRATION_STEPS = [NewRegistrationStep.BusinessDetails, NewRegistrationStep.BusinessRepresentative, NewRegistrationStep.BusinessProfile];
export let BusinessAccountStatus;

(function (BusinessAccountStatus) {
  BusinessAccountStatus["Registered"] = "registered";
  BusinessAccountStatus["WalletConversionInProgress"] = "conversion_in_progress";
  BusinessAccountStatus["Completed"] = "completed";
})(BusinessAccountStatus || (BusinessAccountStatus = {}));

export let BusinessAccountFiles;

(function (BusinessAccountFiles) {
  BusinessAccountFiles["Front"] = "front";
  BusinessAccountFiles["Back"] = "back";
})(BusinessAccountFiles || (BusinessAccountFiles = {}));

export let BusinessAccountMediaTypes;

(function (BusinessAccountMediaTypes) {
  BusinessAccountMediaTypes["Pdf"] = "application/pdf";
  BusinessAccountMediaTypes["PngImage"] = "image/png";
  BusinessAccountMediaTypes["JpegImage"] = "image/jpeg";
})(BusinessAccountMediaTypes || (BusinessAccountMediaTypes = {}));

export let WalletConversionStatus;

(function (WalletConversionStatus) {
  WalletConversionStatus["Idle"] = "idle";
  WalletConversionStatus["Pending"] = "pending";
  WalletConversionStatus["Failed"] = "failed";
  WalletConversionStatus["Completed"] = "completed";
})(WalletConversionStatus || (WalletConversionStatus = {}));

export let BusinessAccountType;

(function (BusinessAccountType) {
  BusinessAccountType["SoleTrader"] = "sole_trader";
  BusinessAccountType["LegalBusiness"] = "legal_business";
  BusinessAccountType["Organization"] = "organization";
})(BusinessAccountType || (BusinessAccountType = {}));

export const BusinessAccountEntityOptions = [BusinessAccountType.SoleTrader, BusinessAccountType.LegalBusiness, BusinessAccountType.Organization];
export const LEGAL_CODE_FIELD = 'legal_code';
export let DocumentGroup;

(function (DocumentGroup) {
  DocumentGroup["IdentityDocuments"] = "identity_documents";
  DocumentGroup["SupportingDocuments"] = "supporting_documents";
})(DocumentGroup || (DocumentGroup = {}));

export let KybFormField;

(function (KybFormField) {
  KybFormField["IdentityDocument"] = "identityDocument";
  KybFormField["IdentityDocumentExpiryDate"] = "identityDocumentExpiryDate";
  KybFormField["SupportingDocuments"] = "supportingDocuments";
})(KybFormField || (KybFormField = {}));